var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wheel-round__multipliers" },
    _vm._l(_vm.colors, function (color) {
      return _c(
        "div",
        {
          key: color.id,
          staticClass: "wheel-round__multiplier multiplier",
          class: [
            "multiplier_" + _vm.getMultiplierColor(color.id),
            { multiplier_winner: color.id === _vm.winColor },
          ],
        },
        [
          _c("div", { staticClass: "multiplier__ratio" }, [
            _vm._v(" " + _vm._s(_vm.getMultiplierRatio(color.id)) + " "),
          ]),
          _c("div", { staticClass: "multiplier__bank" }, [
            _vm._v(" $" + _vm._s(_vm.formatBank(color.totalBankUsd)) + " "),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }